import React from 'react';
import _ from 'lodash';
import request from 'superagent';
import config from '../../../config';
import { Animated } from "react-animated-css";
import { log } from '../../../helpers';

class Card extends React.Component {
    state = {
        turned: false,
        types: [],
        tab: 0,
        bootstrapped: false,
        teams: [],
        haveTeams: false
    }

    componentWillMount() {
        this.setup(this.props);
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.idTournamentSeason !== nextProps.idTournamentSeason) this.setup(nextProps);
    }
    setup = (props) => {
        // DO NOT TOUCH THIS... is GLASS
        const { base, group, idTournamentSeason } = props;
        let gender = _.find(group, g => g.IdTournamentRankAgeGroup_parent === base.IdTournamentRankAgeGroup);
        let types = _.orderBy(_.filter(group, g => g.IdTournamentRankAgeGroup_parent === gender.IdTournamentRankAgeGroup), 'Type');
        if (gender.IsLeaf) {

            request.get(`${config.apiEndpoint}/api/external/rankings/table/${idTournamentSeason}/${gender.IdTournamentRankAgeGroup}`)
                .set('Authorization', `Bearer ${config.apiKey}`)
                .then(({ body: { success, teams } }) => {
                    if (success) { gender.teams = teams; }
                    this.setState({ types, gender, bootstrapped: true, haveTeams: teams.length ? true : false });
                }, reject => {
                    this.setState({ types, bootstrapped: true, fail: true, gender, haveTeams: false });
                });
        } else {

            if (types.length && !this.state.bootstrapped) {
                this.setState({ bootstrapped: true }, () => {
                    const done = _.after(types.length, () => {
                        this.setState({ bootstrapped: true, types, gender, haveTeams: _.find(types, t => (t.teams && t.teams.length > 0)) ? true : false });
                    });
                    types.forEach(t => {

                        request.get(`${config.apiEndpoint}/api/external/rankings/table/${idTournamentSeason}/${t.IdTournamentRankAgeGroup}`)
                            .set('Authorization', `Bearer ${config.apiKey}`)
                            .then(({ body: { success, teams } }) => {
                                if (t.IdTournamentRankAgeGroup === '64CE5CDB-17A3-41F5-B152-574DD972D67D') {
                                    log({ t });
                                    log({ idTournamentSeason });
                                    log({ success, teams })
                                }
                                if (success) { t.teams = teams; }
                            }).finally(() => { done(); });
                    });
                });
            }
        }
    }
    toggle = () => this.setState({ turned: !this.state.turned });
    onTab = (tab, e) => {
        e.stopPropagation && e.stopPropagation();
        this.setState({ tab });
    }
    onPopup = (e) => {
        e.stopPropagation && e.stopPropagation();
        const { onPopup = () => { }, base } = this.props, { tab, gender, types } = this.state;
        if (gender.IsLeaf) {
            onPopup({ base, gender, types: [gender] });
        } else {
            onPopup({ base, gender, types, tab });
        }
    }

    render() {

        const { turned, gender, bootstrapped } = this.state,
            { base = {}, index } = this.props;

        return <div className="w3-third margin-bottom">
            {bootstrapped && gender && <Animated animationIn="zoomIn" className={`flip-card ${turned ? 'turned' : ''}`} animationInDelay={50 * index}>
                <div className="flip-card-inner" onClick={this.toggle}>
                    <div className="flip-card-front d-flex flex-row justify-content-center" onClick={this.onPopup}>
                        <h1 className="anton gray toUpper align-self-center font-25" style={{ fontWeight: 'bolder' }}>{base.TournamentRankAgeGroup} {gender.Gender}</h1>
                    </div>
                </div>
            </Animated>}
        </div>
    }
}

export default Card;



// WEBPACK FOOTER //
// ./src/components/rankings/partials/card.js